import { StepperContext } from "@natera/stepper";
import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { StepperContent } from "@app/components/ui/layout/stepperContent";
import { PredefinedCompanies } from "@app/components/companySelector/companySelector";
import { SubSteps } from "@app/pages/private/simpleOrder/paymentMethod/paymentMethod";
import { SelectInsuranceCompany } from "../selectInsuranceCompany";
import { ProvideCommercialStep } from "../provideComercial";
import { GetProvideInsuranceStep } from "../selectInsuranceCompany/selectInsuranceCompany";

const messages = defineMessages({
  selectCommercialStepHeaderTitle: {
    id: "selectCommercialStepHeaderTitle",
    defaultMessage: "Payment Method",
  },
  selectCommercialStepHeaderSubTitle: {
    id: "selectCommercialStepHeaderSubTitle",
    defaultMessage: "Select insurance company",
  },
});

const commercialCompanies = [
  PredefinedCompanies.Aetna,
  PredefinedCompanies.BlueCrossBlueShield,
  PredefinedCompanies.Cigna,
  PredefinedCompanies.UnitedHealthcareGroup,
  PredefinedCompanies.Humana,
  PredefinedCompanies.Other,
];

interface SubstepsMap {
  other: SubSteps;
  insurance: SubSteps;
}
export type CommercialSteps =
  | SubSteps.SELECT_COMMERCIAL_COMPANY
  | SubSteps.SELECT_COMMERCIAL_COMPANY_FIRST
  | SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND;

type Props = {
  onConfirm: (data: unknown) => void;
};

const SelectCommercialStep: React.FC<Props> = ({ onConfirm }) => {
  const intl = useIntl();
  const { getCurrentStep } = React.useContext(StepperContext);

  const currentStepId = getCurrentStep()?.stepId as CommercialSteps;

  const commercialStepsMapper: Record<CommercialSteps, SubstepsMap> = {
    [SubSteps.SELECT_COMMERCIAL_COMPANY]: {
      other: SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY,
      insurance: SubSteps.PROVIDE_COMMERCIAL_INSURANCE,
    },
    [SubSteps.SELECT_COMMERCIAL_COMPANY_FIRST]: {
      other: SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY_FIRST,
      insurance: SubSteps.PROVIDE_COMMERCIAL_INSURANCE_FIRST,
    },
    [SubSteps.SELECT_COMMERCIAL_COMPANY_SECOND]: {
      other: SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY_SECOND,
      insurance: SubSteps.PROVIDE_COMMERCIAL_INSURANCE_SECOND,
    },
  };

  const otherSubstepId = currentStepId
    ? commercialStepsMapper[currentStepId].other
    : SubSteps.ENTER_OTHER_COMMERCIAL_COMPANY;
  const insuranceSubstepId = currentStepId
    ? commercialStepsMapper[currentStepId].insurance
    : SubSteps.PROVIDE_COMMERCIAL_INSURANCE;

  const getProvideCommercialStep: GetProvideInsuranceStep = (onConfirm) => (
    <ProvideCommercialStep onConfirm={onConfirm} />
  );

  return (
    <StepperContent
      title={intl.formatMessage(messages.selectCommercialStepHeaderTitle)}
      subTitle={intl.formatMessage(messages.selectCommercialStepHeaderSubTitle)}
    >
      <SelectInsuranceCompany
        companies={commercialCompanies}
        otherSubstepId={otherSubstepId}
        insuranceSubstepId={insuranceSubstepId}
        getProvideInsuranceStep={getProvideCommercialStep}
        onConfirm={onConfirm}
      />
    </StepperContent>
  );
};

export default SelectCommercialStep;
